import messages from "messages";
import type { ComponentPropsWithoutRef } from "react";
import { InputGroup, FormControl } from "react-bootstrap";
import getClasses from "utils/getClasses";
import styles from "./SessionTypeNameEditor.module.scss";

const DUPLICATE_ERROR = "Appointment type names have to be unique!";

type Props = {
  value: SessionType["label"] | undefined;
  onChange: ComponentPropsWithoutRef<typeof FormControl>["onChange"];
  isInvalid: boolean | undefined;
  onFocus: () => void;
};

const SessionTypeNameEditor = ({
  value = "",
  onChange,
  isInvalid,
  onFocus,
}: Props) => (
  <InputGroup hasValidation>
    <FormControl
      isInvalid={isInvalid}
      type="text"
      name={"label"}
      value={value}
      onChange={onChange}
      placeholder={messages.enterSessionName}
      onFocus={onFocus}
    />
    {isInvalid && (
      <FormControl.Feedback
        className={getClasses("text-nowrap", styles["error"])}
        type="invalid"
      >
        {DUPLICATE_ERROR}
      </FormControl.Feedback>
    )}
  </InputGroup>
);

export default SessionTypeNameEditor;
